import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import { images } from "../../../assets";
import NoteText from "../../components-text/note-text";
import { ErrorModalContainer } from "../../error-modal/error-modal-style";
import InputBox from "../../input-box/input-box";
import LeftInfoModal from "../../left-info-modal";
import MainButton from "../../main-button";
import SelectBox from "../../select-box/select-box";
import { withCoverages } from "../../../context/mixin/with-coverages";
import { withGeneral } from "../../../context/mixin/with-general";
import { withPolicy } from "../../../context/mixin/with-policy";
import { DocumentType } from "../../../models/gest-doc-models";
import GestDocServices from "../../../services/Gest-Doc.Services";
import { GestDoc } from "../../../services/GestDoc";
import { DocumentDto } from "../../../services/HealthService-dto";
import { changeFileName, downloadFile, getFileExtension, getFileSize } from "../../../utils/utility";
import { RequiredDocDataContainer } from "./required-doc.styles";
import { acceptedFileMimeType } from "../../../constants/acceptedFileMimeType";
import { SIGN_HIRING_STATUS_TYPE } from "../../../constants/hiring";
import { MainTableContainer } from "../../main-table/main-table-style";
import BodyText from "../../components-text/body-text";
import requiredDocuments from "../../../utils/requiredDocuments";
import CrossService from "../../../services/CrossService";
import { createDefaultDocument, getAssociates, getGroupedDocs, getMandatoryDocs, getMissingDocuments } from "./required-doc.helpers";
import { RequiredDocProps, RequiredDocState, DocumentDTO, Associate, Insured } from "./required-doc.dto";
import { requiredDocModalConfig } from "./required-doc-modal-config";

const mime = require('mime-types');

class CrossRequiredDocumentation extends React.Component<RequiredDocProps, RequiredDocState> {

  constructor(props: RequiredDocProps) {
    super(props);

    const associates: Associate[] = getAssociates(props.insureds);

    this.state = {
      newDocument: createDefaultDocument(),
      requiredDocs:[],
      groupedDocs: [],
      missingDocuments:[],
      missingGroupedDocs: [],
      uploadedDocuments: [],
      documentTypes: [],
      associates: associates,
      associatesFilter: associates,
      modalErrorText: "",
      documentIndexToDelete: -1,
      hasAllMandatoryDocs: false,
      hasAllGroupedDocs: true,
      docPersonaTypes: {},
      activeModal: null
    };
  }

  componentDidMount = async () => {
    setTimeout(() => window.scrollTo(0, 0), 100);

    const { data, history, policy } = this.props

    const hasTaker = data && data.taker && Object.keys(data.taker).length !== 0;
    const hasProductId = policy && policy.product && policy.product.products_id;
    if (!hasTaker || !hasProductId) {
      history.push('/contratacion/nueva');
      return;
    }

    await this.getDocumentMasterData();
    this.loadDocumentsInfoFromGestDoc();
  };


  getDocumentMasterData = async () => {
    const { data, policy, setLoading } = this.props;
 
    const isPhysicalPerson = data.taker.physicalPerson;
    const { documentTypes, requiredDocs, groupedDocs, docPersonaTypes} = await requiredDocuments.getDocumentTypes(setLoading, policy.product.products_id, isPhysicalPerson);
    this.setState({ documentTypes, requiredDocs, groupedDocs, docPersonaTypes }, this.refreshRequiredDocumentsStatus);
  }

  
  refreshRequiredDocumentsStatus() {
    const { data, taker } = this.props;
    const { uploadedDocuments, documentTypes, docPersonaTypes } = this.state;
  
    if (!docPersonaTypes) {
      this.setState({ modalErrorText: "Se ha producido un error en la recuperación de los tipos de asegurado. Por favor, inténtelo más tarde." });
      return;
    }
  
    const mandatoryDocs = getMandatoryDocs(documentTypes);
    const groupedDocs = getGroupedDocs(documentTypes);
    const { missingDocuments, missingGroupedDocs, hasAllMandatoryDocs, hasAllGroupedDocs } = getMissingDocuments(mandatoryDocs, data, uploadedDocuments, docPersonaTypes, taker, groupedDocs);
    this.setState({ hasAllMandatoryDocs, hasAllGroupedDocs, missingDocuments, missingGroupedDocs });
  }

  
  loadDocumentsInfoFromGestDoc = async () => {
    const { setLoading, data } = this.props;
    const { documentTypes, docPersonaTypes } = this.state;
    const uploadedDocuments: DocumentDTO[] = [];

    for (let i = 0; i < documentTypes.length; i++) {
      // Recuperamos la información de los documentos del tomador previamente subidos a GestDoc
      if (documentTypes[i].showFor.includes(docPersonaTypes.TOMADOR.value)) {
        const takerDocs = await GestDocServices.searchFileOrderByModifiedAt(setLoading, true,
          GestDoc.getDocumentByDocumentType(documentTypes[i].documentTypeMetadata, data.taker)
        );
        await this.appendUploadedDocumentsFromGestDoc(takerDocs, uploadedDocuments, true);
      }
      
      // Recuperamos la información de los documentos del asegurado previamente subidos a GestDoc
      if (documentTypes[i].showFor.includes(docPersonaTypes.ASEGURADO.value)) {
        for (let a = 0; a < data.insureds.length; a++) {
          const insuredDocs = await GestDocServices.searchFileOrderByModifiedAt(setLoading, true,
            GestDoc.getDocumentByDocumentType(documentTypes[i].documentTypeMetadata, undefined, [data.insureds[a]])
          );
          await this.appendUploadedDocumentsFromGestDoc(insuredDocs, uploadedDocuments, false);
        }
      }
    }
    this.setState({ uploadedDocuments }, this.refreshRequiredDocumentsStatus)
  }


  async appendUploadedDocumentsFromGestDoc( docs: any, uploadedDocuments: DocumentDTO[], isTaker: boolean) {
    const entries = docs && docs.list && docs.list.entries ? docs.list.entries : [];

    for (const item of entries) {
      const uploadedDoc = await this.getFileInfoFromGestDoc(item.entry, isTaker);

      if (uploadedDoc && uploadedDoc.id && !uploadedDocuments.some(d => d.id === uploadedDoc.id)) {
        uploadedDocuments.push(uploadedDoc);
        break;
      }
    }
  }


  getFileInfoFromGestDoc = async (entry: any, isAssociatedTaker: boolean) => {
    const fileInfoDNI = await GestDocServices.getFileInfo(this.props.setLoading, true, entry.id);
    const { properties, content } = fileInfoDNI.entry;

    const isTaker = properties["ins2:processEntity"] === 'Tomador';
    const dniAssociated = properties["ins2:insured1Nif"];

    return isTaker === isAssociatedTaker
      ? {
          id: entry.id,
          name: entry.name,
          date: entry.createdAt,
          description: '',
          type: this.getDocTypeValue(properties["ins2:documentType"]),
          associatedTo: dniAssociated ? this.getAssociated(dniAssociated, isTaker) : '-1',
          size: content.sizeInBytes
        }
      : {
          id: '',
          name: '',
          description: '',
          type: '',
          associatedTo: '',
          size: 0
        };
  }


  getDocTypeValue(documentType: DocumentType | string | undefined): string {
    const { documentTypes } = this.state;
    const elem = documentTypes.find(doc => doc.documentTypeMetadata === documentType);
    return elem ? elem.value : '';
  }


  getAssociated(nif: string, isTaker: boolean): string {
    if (isTaker) {
      return '-1';
    }
    const index = this.props.data.insureds.findIndex((insured: any) => insured.docNumber === nif);
    return index >= 0 ? String(index) : '';
  }


  onDocumentTypeChange(value: string) {
    const { newDocument, associates, documentTypes, docPersonaTypes } = this.state;

    const newAssociatesFilter: Associate[] = [];
    const doc = documentTypes.find(d => d.value === value);
    if (doc) {
      const docShowFor = doc.showFor.split("-");
      // Comprobamos para el documento quien lo tiene disponible y quien obligatorio
      associates.forEach((insured, idx) => {
        const { isStudent, index } = insured;
        const isForeignStudent = isStudent && index !== -1 && docShowFor.includes(docPersonaTypes.ASEGURADO_ESTUDIANTE_EXTRANJERO.value);
        const isValidTaker = index === -1 && (docShowFor.includes(docPersonaTypes.TOMADOR.value) || (docPersonaTypes.EMPRESA && docShowFor.includes(docPersonaTypes.EMPRESA.value)));
        const isValidInsured = (index !== -1 && docShowFor.includes(docPersonaTypes.ASEGURADO.value)) || (index === -1 && idx === 1 && docShowFor.includes(docPersonaTypes.ASEGURADO.value));

        if (docShowFor.length === 0 || isForeignStudent || isValidTaker || isValidInsured) {
          newAssociatesFilter.push(insured);
        }
      });
    }

    this.setState({  newDocument: {
        ...newDocument,
        docType: value,
        associatedTo: '',
      }, associatesFilter: newAssociatesFilter });
  }


  onAssociatedToChange(value: string) {
    const { newDocument } = this.state;
    this.setState({ newDocument: {
        ...newDocument,
        associatedTo: value,
      }
    });
  }


  onDescriptionChange(value: string) {
    const { newDocument } = this.state;
    this.setState({ newDocument: {
        ...newDocument,
        description: value,
      }
    });
  }


  onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const { newDocument } = this.state;
      this.setState({ newDocument: {
        ...newDocument,
        file: event.target.files[0],
        }
      });
    }
  };


  addDocumentForPendingUpload() {
    const { newDocument, uploadedDocuments } = this.state;
    // Si el asegurado es el tomador y el documento esta disponible para tomador y asegurado se le asigna al tomador.
    const associateIndex = newDocument.associatedTo === '-1' ? [-1] : this.getAssociatedIndexes();

    if (uploadedDocuments.find(doc => doc.type === newDocument.docType && doc.associatedTo === associateIndex[0].toString())) {
      this.setState({ activeModal: "replaceDocument" });
      return;
    } 
    this.addPendingDocument();
  }


  getAssociatedIndexes() {
    const { newDocument, associates, documentTypes, docPersonaTypes } = this.state;
    const { data } = this.props;
    
    const doc = documentTypes.find(x => x.value === newDocument.docType)
    if (doc && doc.showFor.includes(docPersonaTypes.TOMADOR.value) && newDocument.associatedTo === data.taker.docNumber) {
      return [-1];
    }
    return associates.filter((associate) => associate.document === newDocument.associatedTo).map((associate) => associate.index)
  }


  async addPendingDocument() {
    const { newDocument, documentTypes, docPersonaTypes } = this.state;
    const { file, docType, associatedTo, description } = newDocument;

    if (!(file && docType)) {
      this.showErrorModal("Primero debe seleccionar un archivo para subir y un tipo.");
      return;
    }

    const fileExtension = getFileExtension(file.name);
    const mimeType = mime.lookup(fileExtension);

    const isValidFile = mimeType && (acceptedFileMimeType.includes(mimeType) || mimeType.includes("image"));
    if (!isValidFile) {
      this.showErrorModal(`No se permite la extensión ${fileExtension} del fichero introducido. Revise los tipos aceptados.`);
      return;
    }

    const newFileName = `${docType}${associatedTo !== '-1' ? `_${associatedTo}` : ""}_${moment().format("YYYYMMDDHHmmss")}.${fileExtension}`;
    const renamedFile = changeFileName(file, newFileName);

    const associateIndex = associatedTo === '-1' ? [-1] : this.getAssociatedIndexes()

    const doc = documentTypes.find(d => d.value === docType);
    if (doc && doc.obligatorio === doc.showFor && associateIndex[0] === -1 &&
        [docPersonaTypes.ASEGURADO.value, docPersonaTypes.ASEGURADO_ESTUDIANTE_EXTRANJERO.value].includes(doc.obligatorio)
    ) {
      associateIndex[0] = 0;
    }

    // Los documentos se almacenan temporalmente hasta que el usuario pulse "Siguiente"
    this.addDocumentToUploadQueue({
      name: newFileName,
      description: description,
      type: docType,
      associatedTo: associateIndex[0].toString(),
      file: renamedFile,
      isNew: true
    });
  }


  addDocumentToUploadQueue(newDoc: DocumentDTO) {
    const uploadedDocuments = [...this.state.uploadedDocuments];

    const matchesDocument = (doc: DocumentDTO) => doc.type === newDoc.type && doc.associatedTo === newDoc.associatedTo;

    uploadedDocuments.forEach(doc => {
      if (matchesDocument(doc)) doc.hidden = true;
    });
    // Si ya existe un documento pendiente de subida del mismo tipo y para el mismo asociado, se sustituye para evitar duplicados
    const existingNewDocIndex = uploadedDocuments.findIndex(doc => matchesDocument(doc) && doc.isNew === true);
    if (existingNewDocIndex !== -1) uploadedDocuments[existingNewDocIndex] = newDoc;
    else uploadedDocuments.push(newDoc);

    this.setState({ uploadedDocuments }, () => {
      this.clearForm();
      this.refreshRequiredDocumentsStatus();
    });
  }
 

  clearForm() {
    this.setState({
      newDocument: createDefaultDocument()
    });
  }


  getDocTypeLabel(type: string | undefined): string {
    const { documentTypes } = this.state
    const elem = documentTypes.find(doc => doc.value === type);
    return elem ? elem.label : '';
  }


  getAssociatedName(associate: string) {
    const { associates } = this.state;
    const infoAssociated = associates.filter(a => a["title"] !== "Ninguno").find(a => (a.index).toString() === associate);
    return infoAssociated ? infoAssociated.title : "Ninguno";
  }


  async downloadDocument(document: any) {
    // Descarga para un documento recién añadido y todavía no sincronizado con GestDoc.
    if (!document.id) {
      downloadFile(document.file, document.name, document.type, true);
      return;
    }

    // Descarga para un documento almacenado en GestDoc
    const { setLoading } = this.props;
    const file = await GestDocServices.getFile(setLoading, true, document.id);
    if (file && file.fileData) {
      downloadFile(file.fileData, file.fileName, file.fileType, true);
    } 
    else this.showErrorModal("Se ha producido un error al descargar el archivo.");
  }


  async confirmDeleteModal(index: number) {
    this.setState({ activeModal: 'deleteDocument', documentIndexToDelete: index });
  }


  tryGoToNextStep = async () => {
    const { hasAllMandatoryDocs, hasAllGroupedDocs } = this.state;
    const { data, history, nextStep, step, saveHiring, readOnly } = this.props;

    if (readOnly) {
      history.push(nextStep.getNextStepNavigationPath((data.taker.physicalPerson) ? step + 1 : step));
      return;
    }
    
    if (!hasAllMandatoryDocs || !hasAllGroupedDocs) {
      this.setState({ activeModal: 'requiredDocs' });
      return;
    }

    // Se obtienen los documentos previamente subidos a GestDoc y se incorporan los nuevos para la nueva subida
    const hasUploadDocError = await this.submitDocumentationToSenda();
    if (!hasUploadDocError) {
      this.refreshRequiredDocumentsStatus();
      saveHiring();
      history.push(nextStep.getNextStepNavigationPath((!data.taker.physicalPerson) ? step + 1 : step));
      return;
    }
  }


  async submitDocumentationToSenda(): Promise<boolean> {
    const { data } = this.props;

    // Se intenta actualizar la contratación con una firma solicitada
    if (data && data.signData && data.signData.signStatus === SIGN_HIRING_STATUS_TYPE.REQUESTED) {
      this.setState({ activeModal: 'cancelSign' })
      return false;
    }
    return await this.validateAndSubmit();
  }


  async validateAndSubmit(): Promise<boolean> {
    const { uploadedDocuments } = this.state;
    const { setLoading, cotizacion, areaEndpoint } = this.props;

    const filesInfoArray: DocumentDto[] = [];
    const filesArray: File[] = [];
    const visibleDocuments = uploadedDocuments.filter(doc => !doc.hidden);
    await Promise.all(visibleDocuments.map(async (doc) => {
      const fileInfo = {
        [doc.name]: {
          type: doc.type,
          associatedTo: doc.associatedTo,
        },
      };

      // Documentos nuevos
      if (!doc.id && doc.file) {
        filesInfoArray.push(fileInfo);
        filesArray.push(doc.file);
      }
      
      // Recuperamos los documentos ya almacenados en GestDoc
      else if (doc.id && !doc.file) {
        const fileWithId: any = await GestDocServices.getFile(setLoading, true, doc.id);
        if (fileWithId) {
          filesInfoArray.push(fileInfo);
          filesArray.push(new File([fileWithId.fileData], fileWithId.fileName))
        }
      }
    }))

    if (!filesArray.length) return false;

    // Los documentos adjuntos no pueden superar los 5MB
    const totalSize = filesArray.reduce((size, file) => size + file.size, 0);
    if (totalSize >= (1048576 * 5)) {
      this.setState({ activeModal: "maxSize" });
      return true;
    }

    try {
      await CrossService.uploadDocumentsToSenda(setLoading, true,
        {
          cotizacion,
          fileInfo: filesInfoArray,
          files: filesArray,
        },
        areaEndpoint
      );
      return false;
    } catch (error) {
      this.setState({ modalErrorText: String(error) });
      return true;
    }
  }


  showErrorModal = (text: string = "Ha ocurrido un error.") => this.setState({ modalErrorText: text });


  handleModalAccept = async () => {
    const {activeModal, documentIndexToDelete} = this.state;
    try {
      switch (activeModal) {
        case "deleteDocument":
          await this.deleteDocument(documentIndexToDelete);
          break;
        case "cancelSign":
          this.props.removeSign();
          this.validateAndSubmit();
          break;
        case "replaceDocument":
          this.addPendingDocument();
          break;
      }
    } finally {
      this.closeModal();
    }
  };


  closeModal = () => {
    this.setState({
      activeModal: null,
      documentIndexToDelete: -1,
    });
  };


  async deleteDocument(index: number) {
    const { uploadedDocuments } = this.state;
    const fileToDelete = uploadedDocuments[index];

    // Se oculta ese documento y todos aquellos que coincidan en tipo y asociado
    const updatedDocuments = uploadedDocuments.filter((_, i) => i !== index)
      .map(doc => ({
        ...doc,
        hidden: doc.type === fileToDelete.type && doc.associatedTo === fileToDelete.associatedTo ? false : doc.hidden,
      }));

    this.setState({ uploadedDocuments: updatedDocuments }, this.refreshRequiredDocumentsStatus);
  }


  render() {
    const {
      newDocument,
      uploadedDocuments,
      documentTypes,
      associatesFilter,
      hasAllMandatoryDocs,
      requiredDocs,
      hasAllGroupedDocs,
      missingDocuments,
      activeModal,
      modalErrorText,
      missingGroupedDocs
    } = this.state;
    const { readOnly, productType } = this.props;

    const isAddDocumentDisabled = readOnly || !(newDocument.file && newDocument.docType && newDocument.associatedTo);
    const modal = activeModal && requiredDocModalConfig[activeModal];

    return (
      <RequiredDocDataContainer>
        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h2>DOCUMENTACION REQUERIDA</h2>
          </div>
        </div>

        <div className="content-wrapper bottomMargin20 filesSection" ref={''}>
          <div className="personal-data-wrapper">
            {!readOnly && (
              <div>
                <div className="data-title">
                  <h5>ADJUNTAR DOCUMENTOS</h5>
                </div>

                <div className="colSin-100 topMargin20">

                  <div className="colSin-50 rightPadding20">
                    <div className="selectBox">
                      <SelectBox
                        optionsText={documentTypes}
                        optionKey={"value"}
                        optionValue={"label"}
                        defaultValue={newDocument.docType}
                        initialValue={newDocument.docType}
                        onChange={(value: string) => this.onDocumentTypeChange(value)}
                        required={true}
                        disabled={readOnly}
                      />
                      <label>Tipo de documento</label>
                    </div>
                  </div>

                  <div className="colSin-50 rightPadding20">
                    <div className="selectBox">
                      <SelectBox
                        optionsText={associatesFilter}
                        optionKey={"document"}
                        optionValue={"title"}
                        defaultValue={newDocument.associatedTo}
                        initialValue={newDocument.associatedTo}
                        onChange={(value: string) => this.onAssociatedToChange(value)}
                        required={false}
                        disabled={readOnly}
                      />
                      <label>Asegurado</label>
                    </div>
                  </div>

                  <div className="colSin-100 rightPadding20">
                    <div className="inputBox custom-file-upload">
                      <div className="colSin-100">
                        <InputBox
                          type={"text"}
                          required={false}
                          errorCode={""}
                          disabled={readOnly}
                          cleanValue={true}
                          value={newDocument.description ? newDocument.description : ""}
                          onChange={(value: string) => this.onDescriptionChange(value)}
                        />
                      </div>
                      <label>Descripción</label>
                    </div>
                  </div>

                </div>

                <div className="colSin-100 topMargin20">
                  <div className="colSin-50 rightPadding20">
                    <div className="inputBox custom-file-upload">

                      <div className="colSin-70 required">
                        <input type="text" readOnly value={(newDocument.file ? newDocument.file.name : "")} disabled={readOnly} />
                      </div>

                      <div className="colSin-30">
                        <label className="custom-file-upload-button topMargin5">
                          <input type="file" onChange={this.onFileChange} accept={acceptedFileMimeType.toString()} />
                          <MainButton
                            onClick={() => { return true }}
                            text="Buscar"
                            disabled={readOnly}
                          />
                        </label>
                      </div>

                      <label>Adjuntar documento</label>
                    </div>
                  </div>

                  <div className="colSin-50 rightPadding20 topMargin15">
                    <label className="custom-file-upload">
                      <div className={"upload-buttons"}>
                        <MainButton
                          type={isAddDocumentDisabled ? "disabled" : ""}
                          onClick={() => this.addDocumentForPendingUpload()}
                          text="Adjuntar Documento"
                          icon={true}
                          iconImg={images.IconUploadBlue}
                          disabled={isAddDocumentDisabled}
                        />
                      </div>
                    </label>
                  </div>

                </div>
              </div>
            )}
            {!readOnly && !hasAllMandatoryDocs && requiredDocs.length >0 &&
              <div className="colSin-100 topMargin20">
                <NoteText className="required-docs">
                  <p className="info">Documentos obligatorios:</p>
                  <ul>
                    {requiredDocs.map((doc, index) => <li key={`doc-req-${index}`}>{(doc)}</li>)}
                  </ul>    
                </NoteText>
              </div>
            }
            { !hasAllGroupedDocs && (
              <div className="colSin-100 topMargin20">
                <NoteText className="required-docs">
                  <p className="regular">
                    {`Alguno de los documentos añadidos requiere de documentación complementaria. Por favor, adjunte también los documentos faltantes (${[...new Set(missingGroupedDocs)].join(', ')}).`}
                  </p>
                </NoteText>
              </div>
            )}
            {requiredDocs.length === 0 && hasAllGroupedDocs && (
              <div className="colSin-100 topMargin20">
                <NoteText className="required-docs">
                  <p className="regular">No existen documentos obligatorios.</p>
                </NoteText>
              </div>
            )}

            <div className="colSin-100 topMargin20">
              {uploadedDocuments && uploadedDocuments.length > 0 &&
                <>
                  <MainTableContainer className="table noZebra uploadedTable">
                    <thead>
                      <tr>
                        {["Tipo de documento", "Asegurado", "Opciones", "Tamaño *"].map((column, index) => (
                          <th key={`column-${index}`}>
                            <BodyText className="dimmed-mini-title"><p>{column}</p></BodyText>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {uploadedDocuments.filter(row => !row.hidden).reverse().map((row, index) => {
                        const size = row.size ? getFileSize(row.size) : row.file ? getFileSize(row.file.size) : "";

                        return (<tr className="main-table-row" key={`row-${index}`}>
                          <td>
                            <BodyText className="dimmed-mini-body">
                              <p>{this.getDocTypeLabel(row.type)}</p>
                            </BodyText>
                          </td>
                          <td>
                            <BodyText className="dimmed-mini-body">
                              <p>{this.getAssociatedName(row.associatedTo)}{row.isNew && "(Nuevo)"}</p>
                            </BodyText>
                          </td>
                          <td>
                            <div className="uploadedFileTable">
                              <MainButton
                                key={`downloadBtnTable${index}`}
                                onClick={() => this.downloadDocument(row)}
                                text=""
                                icon={true}
                                iconImg={images.IconEyewhite}
                              />
                              {(!readOnly && !row.id && 
                                <MainButton
                                  key={`deleteBtnTable${index}`}
                                  onClick={() => this.confirmDeleteModal(index)}
                                  text=""
                                  icon={true}
                                  iconImg={images.IconDeleteWhite}
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <BodyText className="dimmed-mini-body">
                              <p>{size}</p>
                            </BodyText>
                          </td>
                        </tr>
                      )})}
                    </tbody>
                  </MainTableContainer>
                  <p className="text-max-size">* El tamaño máximo de la totalidad de ficheros a adjuntar es de 5MB.</p>
                </>
              }
            </div>
          </div>
        </div>

        <div className="colSin-100 topMargin20 bottomMargin20">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={() => this.props.history.push(`/contratacion/nueva/${productType}/garantias`)}
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                text="Siguiente"
                onClick={this.tryGoToNextStep}
              />
            </div>
          </div>
        </div>

        { modal && 
          <LeftInfoModal
            {...modal}
            active
            list={activeModal === "requiredDocs" ? missingDocuments : undefined}
            close={this.closeModal}
            onClickAccept={this.handleModalAccept}
          />
        }
        
        { modalErrorText &&
          <ErrorModalContainer className="active">
            <div className="recover-modal">
              <div className="server-error">
                <p>{modalErrorText}</p>
              </div>
              <div className="button-error">
                <MainButton text="Aceptar" onClick={() => this.setState({ modalErrorText: "" })} />
              </div>
            </div>
          </ErrorModalContainer>
        }
      </RequiredDocDataContainer>
    );
  }
}

export default withCoverages(withPolicy(withGeneral(withRouter(CrossRequiredDocumentation))));